import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useState, Fragment } from "react";
import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface ICancelPaymentButton {
  id: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CustomConfirmButton = ({ id }: ICancelPaymentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleCancelPayment, { loading }] = useMutation(
    {
      type: "delete",
      resource: `payments`,
      payload: {
        id: id,
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully cancel payment.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed cancel the payment, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Button
      onClick={handleCancelPayment}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const CancelPaymentButton = ({ id }: ICancelPaymentButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Cancel Payment`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#f44336" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Cancel Payment</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to cancel payment ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CustomConfirmButton id={id} />
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default CancelPaymentButton;
